import React from "react";
import { cn } from "@/lib/utils";

const Button = React.forwardRef(
  ({ className, variant = "default", size = "default", ...props }, ref) => {
    const variants = {
      default: "bg-red-500 text-white rounded-t-lg",
      destructive:
        "bg-destructive text-destructive-foreground hover:bg-destructive/90 hover:shadow-lg transition-all duration-200",
      outline: "text-gray-0 duration-200",
      secondary: "gradient-secondary text-foreground hover:shadow-md transition-all duration-200",
      ghost: "hover:bg-primary/10 hover:text-primary transition-all duration-200",
      link: "text-primary underline-offset-4 hover:underline",
    };

    const sizes = {
      default: "h-52 p-4",
      sm: "h-9 rounded-md p-2 text-sm",
      lg: "h-12 rounded-lg px-8 text-base",
      icon: "h-10 w-10",
    };

    return (
      <button
        className={cn(
          "ring-offset-background focus-visible:ring-ring inline-flex items-center justify-center text-sm font-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
          variants[variant],
          sizes[size],
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Button.displayName = "Button";

export { Button };
